import { useGameStore } from './stores/gameStore'
import MainMenu from './ui/MainMenu'
import Lobby from './ui/Lobby'
import WaitingRoom from './ui/WaitingRoom'
import Game from './ui/Game'

function App() {
  const screen = useGameStore((state) => state.screen)

  return (
    <div className="w-full h-full">
      {screen === 'menu' && <MainMenu />}
      {screen === 'lobby' && <Lobby />}
      {screen === 'waiting' && <WaitingRoom />}
      {screen === 'game' && <Game />}
    </div>
  )
}

export default App
